import type { components } from '@/types/apiSchema';

type CandidateJobNote = components['schemas']['CandidateJobNoteResponse'];

/**
 * The complete pre-screen note behind the assessment: Finlay's notes from its
 * call (`AiPrescreen`) or a note someone added after a human call
 * (`Prescreen`). The assessment ledger condenses it, so the hiring manager
 * opens this when the assessment leaves something out. A newer note, for
 * example from a repeated call, supersedes an earlier one.
 */
export function latestPrescreenNote(
  notes: CandidateJobNote[] | undefined,
): CandidateJobNote | null {
  const prescreenNotes = (notes ?? []).filter(
    (note) =>
      (note.type === 'AiPrescreen' || note.type === 'Prescreen') &&
      note.content.trim(),
  );
  if (prescreenNotes.length === 0) return null;
  return prescreenNotes.reduce((latest, note) =>
    note.createdAt > latest.createdAt ? note : latest,
  );
}
